import { combineReducers } from 'redux'

import listTransaction from './listTransaction'
import finishTransaction from './finishTransaction'
import rejectTransaction from './rejectTransaction'
import editOrderTransaction from './editOrderTransaction'

export default combineReducers({
  listTransaction: listTransaction,
  finishTransaction: finishTransaction,
  rejectTransaction: rejectTransaction,
  editOrderTransaction: editOrderTransaction
})
